export enum AlternativeTextLinkrel {
	SAVE = 'save',
	DELETE = 'delete',
	SPALTEN_EINTRAG = 'spaltenEintrag',
}

export enum AlternativeTextListLinkRel {
	ALT_SCHIFFSPAPIERE_TEXT_LIST = 'alternativeTextList',
}
